































import { Component, Mixins } from "vue-property-decorator";
import { State } from "vuex-class";
import { ReferralInfo, User } from "@foxone/api/src/models/foxone";
import ShareGuideModal from "basis/components/invite/ShareGuideModal.vue";
import InviteStateAvaliable from "basis/components/invite/InviteStateAvaliable.vue";
import InviteStateInvited from "basis/components/invite/InviteStateInvited.vue";
import InviteStateSelf from "basis/components/invite/InviteStateSelf.vue";
import ReferralSetSuccessModal from "basis/components/invite/ReferralSetSuccessModal.vue";
import mixins from "@/mixins";

@Component({
  components: {
    ShareGuideModal,
    InviteStateAvaliable,
    InviteStateInvited,
    InviteStateSelf,
    ReferralSetSuccessModal
  }
})
class Share extends Mixins(mixins.page) {
  @State(state => state.basis.account.referral) referral!: ReferralInfo;

  needMigrate = true;

  inviter: User | null = null;

  accepting = false;

  loading = true;

  successModal = false;

  get title() {
    const inviter = (this.inviter && this.inviter.fullname) || "";
    return this.$t("invite.title", { name: inviter }) as string;
  }

  get appbar(): any {
    const inviter = (this.inviter && this.inviter.fullname) || "";
    return {
      title: this.$t("invite.title", { name: inviter }) as string,
      color: "#EF8343",
      dark: true
    };
  }

  get themeColor(): any {
    return "#EF8343";
  }

  get background() {
    return this.$i18n.locale === "en"
      ? require("@/assets/images/invite_bg_en.png")
      : require("@/assets/images/invite_bg_zh.png");
  }

  get code() {
    return (this.$route.query.code || "") as string;
  }

  get meta() {
    const referralCode = (this.referral && this.referral.referral_code) || "";
    const myInviter = (this.referral && this.referral.inviter) || "";
    const isLogged = Boolean(referralCode);
    const isInvited = Boolean(myInviter);
    const isSelf = isLogged && referralCode === this.code;
    return {
      myInviter,
      referralCode,
      isInvited,
      isLogged,
      isSelf
    };
  }

  mounted() {
    this.requestUserByCode(this.code);
    const shouldSetCode = localStorage.getItem("set_referral_code_immediately");
    if (shouldSetCode) {
      localStorage.removeItem("set_referral_code_immediately");
      const section = this.$refs.invite_avaliable_section as any;
      section && section.requestSetReferralCode();
    }
  }

  async requestUserByCode(code: string) {
    this.loading = true;
    try {
      const user = await this.$api.foxone.getUserByReferralCode(code);
      this.inviter = user;
      if (this.$route.path === "/basis/invite") {
        this.setProperties();
      }
    } catch (error) {
      console.log(error);
    }
    this.loading = false;
  }

  handleSetReferralSuccess() {
    this.successModal = true;
  }
}
export default Share;
